import { render, staticRenderFns } from "./Game4.vue?vue&type=template&id=62995e1d&scoped=true&"
import script from "./Game4.vue?vue&type=script&lang=js&"
export * from "./Game4.vue?vue&type=script&lang=js&"
import style0 from "./Game4.vue?vue&type=style&index=0&id=62995e1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62995e1d",
  null
  
)

export default component.exports